import { usePage } from '@inertiajs/vue3';

export function useCurrentLocale() {
    return usePage().props.locale;
}
